import * as React from 'react'
import { AccentButton } from '../controls/AccentButton';
import { accentUtils, t } from '../services/HelperService';
import { AccentDialog } from './AccentDialog'
import { SignaturePad } from './../controls/documents/SignaturePad'
import { isMobileOnly } from '../controls/AccentDisplay';
export const SignatureDlg = React.memo(props => {

    const onClose = props.onClose;
    const [signatureRefreshKey, setSignatureRefreshKey] = React.useState(1);
    const [signature, setSignature] = React.useState(null);
    const [signerName, setSignerName] = React.useState(props.signer ?? null);
    const [initials, setInitials] = React.useState(null);

    // SignaturePad calls: onSignatureSave(signature, signerName, initials)
    const onSignatureSave = React.useCallback((sig, signer, initials) => {
        setSignature(sig);
        setSignerName(signer);
        setInitials(initials);
    }, []);

    const recapture = React.useCallback(e => {
        setSignature(null);
        setSignatureRefreshKey(k => k + 1);
    }, [setSignature, setSignatureRefreshKey]);

    const close = React.useCallback(e => {

        onClose({ signature: signature, signer: signerName, initials: initials });
    },[onClose, signature, signerName, initials])


    const allowClose = !accentUtils.isNull(signature);
    const showCancel = !accentUtils.isNull(signature);
    return <AccentDialog
        fullscreen={isMobileOnly}
        maxWidth={isMobileOnly ? undefined : 600}
        noCancel={ !showCancel}
        headerContent={t("application_strings.application.dialogs.signature.title")}
        onClose={onClose}
        actionsContent={!showCancel ? undefined :   [
            <AccentButton key="3" tagName="closeBtn" disabled={!allowClose} onClick={recapture}>{t("application_strings.application.buttons.recapture")}</AccentButton>,
            <AccentButton key="2" tagName="closeBtn" disabled={!allowClose} onClick={close}>{t("application_strings.application.buttons.ok")}</AccentButton>
        ]}
    >
        <SignaturePad key={signatureRefreshKey} onSignatureSave={onSignatureSave} signer={props.signer} readOnly={allowClose} onCancel={e => onClose({ canceled: true })} />
    </AccentDialog >;

});